import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import Register from '../pages/account/register/Register';
import Confirmation from '../pages/account/register/components/confirmation';
import Setup from '../pages/account/register/components/Setup';


class Router extends Component {
  render () {
    return (
      <MainWrapper>
        <main>
          <Switch>
            <Route exact path='/' component={Register} />
            <Route exact path='/confirmation' component={Confirmation} />
            <Route path='/setup/:uuid' component={Setup} />
          </Switch>
        </main>
      </MainWrapper>
    );
  }
}

export default withRouter(Router);



// WEBPACK FOOTER //
// ./src/app/Router.js